import {
  GET_CONTACT_US_SETUP,
  GET_CONTACT_US_SETUP_FAILED,
  GET_CONTACT_US_SETUP_SUCCESS,
  GET_USER_LIST,
  GET_USER_LIST_FAILED,
  GET_USER_LIST_SUCCESS,
  HIDE_SELECT_USERS_MODAL,
  OPEN_SELECT_USERS_MODAL,
  RESET_USER_LIST,
  UPDATE_CONTACT_DATA,
  UPDATE_CONTACT_DATA_FAILED,
  UPDATE_CONTACT_DATA_SUCCESS,
  UPDATE_CONTACT_US_SETUP,
  UPDATE_CONTACT_US_SETUP_FAILED,
  UPDATE_CONTACT_US_SETUP_SUCCESS,
} from "./actionTypes"

export const getContactUsSetup = params => ({
  type: GET_CONTACT_US_SETUP,
  payload: params,
})

export const getContactUsSetupSuccess = response => ({
  type: GET_CONTACT_US_SETUP_SUCCESS,
  payload: response,
})

export const getContactUsSetupFailed = error => ({
  type: GET_CONTACT_US_SETUP_FAILED,
  payload: error,
})

export const getUserList = params => ({
  type: GET_USER_LIST,
  payload: params,
})

export const getUserListSuccess = response => ({
  type: GET_USER_LIST_SUCCESS,
  payload: response,
})

export const getUserListFailed = error => ({
  type: GET_USER_LIST_FAILED,
  payload: error,
})

export const resetUserList = () => ({
  type: RESET_USER_LIST,
  payload: {},
})

export const openSelectUsersModal = () => ({
  type: OPEN_SELECT_USERS_MODAL,
  payload: {},
})

export const hideSelectUsersModal = () => ({
  type: HIDE_SELECT_USERS_MODAL,
  payload: {},
})

export const updateContactUsSetup = params => ({
  type: UPDATE_CONTACT_US_SETUP,
  payload: params,
})

export const updateContactUsSetupSuccess = response => ({
  type: UPDATE_CONTACT_US_SETUP_SUCCESS,
  payload: response,
})

export const updateContactUsSetupFailed = error => ({
  type: UPDATE_CONTACT_US_SETUP_FAILED,
  payload: error,
})

export const updateContactData = params => ({
  type: UPDATE_CONTACT_DATA,
  payload: params,
})

export const updateContactDataSuccess = response => ({
  type: UPDATE_CONTACT_DATA_SUCCESS,
  payload: response,
})

export const updateContactDataFailed = error => ({
  type: UPDATE_CONTACT_DATA_FAILED,
  payload: error,
})
